import React,{Fragment} from "react";
import {BorderOuterOutlined} from "@ant-design/icons"

export default {
    Renderer: (props) =>
    {

        const blockStyle=props.data.blockStyle || {}
        let defaultStyle={display:"flex",flexDirection:"column"}

        return(
            <div style={{...defaultStyle,...blockStyle}}>
                {props.children}
            </div>
        )

    },
    id: 'block-empty',
    title: 'Block',
    description: "Conteneur vide personnalisable.",
    icon: <BorderOuterOutlined />,
    version: 1,
    allowClickInside: true,
    noStyle:true
}
